import { call, put, select } from 'redux-saga/effects';
import { LOBBY_MESSAGE_NOTIFICATION_ID } from 'features/notifications/constants';
import { addJoinNotification } from 'features/notifications/join-screen-notifications/addJoinNotification';
import { signalingLobbyMessageReceived } from 'features/room/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import { updateJoinNotification } from 'features/notifications/join-screen-notifications/updateJoinNotification';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';
import { Action } from '@reduxjs/toolkit';
import { EventUser } from 'services/signaling';
import { resolveEventUserSaga } from 'features/users/utils/resolveEventUser';
import { User } from 'features/users/types';

function getNotificationContent(initiator: EventUser | undefined, message: string): string {
  if (initiator?.name) {
    return i18n.t('notifications:lobby_message.message_received', {
      username: initiator.name,
      message,
    });
  }

  return i18n.t('notifications:lobby_message.message_received_unnamed', {
    message,
  });
}

export function* onLobbyMessageReceivedSaga(
  action: ReturnType<typeof signalingLobbyMessageReceived>
) {
  const { data, initiator } = action.payload;
  const { message } = data;

  const hasActiveNotification: boolean = yield call(
    notification.isActive,
    LOBBY_MESSAGE_NOTIFICATION_ID
  );

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  const resolvedInitiator: User | EventUser | undefined = yield call(
    resolveEventUserSaga,
    initiator
  );
  const displayInitiator = resolvedInitiator;

  const notificationPayload = {
    content: getNotificationContent(
      displayInitiator || ({ name: undefined } as EventUser),
      message
    ),
    initiatorId: initiator.id,
    initiator: e2eeEnabled ? undefined : displayInitiator,
    scope: ['lobby'],
  };

  // Create a new notification
  if (!hasActiveNotification) {
    const joinNotificationThunk: Action = yield call(addJoinNotification, notificationPayload, {
      toastId: LOBBY_MESSAGE_NOTIFICATION_ID,
    });
    yield put(joinNotificationThunk);

    return;
  }

  // Update the existing notification
  const updateNotificationThunk: Action = yield call(
    updateJoinNotification,
    LOBBY_MESSAGE_NOTIFICATION_ID,
    notificationPayload
  );
  yield put(updateNotificationThunk);
}
